<div class="product-card-item">
    <input type="checkbox" *ngIf="showCheckbox" class="product-card-checkbox-container" [checked]="isSelected" (change)="onCheckboxChange($event)" />
    <div class="product-card-image-box">
        <a [ngClass]="{ 'product-card-image-wrapper': true, 'product-card-image-sm': showSmallImages }" href="{{ product.AbsoluteUrl }}">
            <img
                [ngClass]="{ 'product-card-image-main': true, 'main-image-hover': hasAlt, 'product-card-image-sm': showSmallImages }"
                alt="{{ product.Description }}"
                src="{{ product.ImageHtml.Src }}"
                srcset="{{ product.ImageHtml.SrcSet }}"
                sizes="{{ product.ImageHtml.Sizes }}"
                (error)="setFallbackImage($event, 'main')"
            />

            <img
                *ngIf="hasAlt"
                [ngClass]="{ 'product-card-image-alt': true, 'product-card-image-sm': showSmallImages }"
                alt="{{ product.Description }}"
                src="{{ product.AltImageHtml.Src }}"
                srcset="{{ product.AltImageHtml.SrcSet }}"
                sizes="{{ product.ImageHtml.Sizes }}"
                (error)="setFallbackImage($event, 'alt')"
            />
        </a>
    </div>
    <div class="product-card-description">
        <h3 class="product-card-name text-center">
            <a href="{{ product.AbsoluteUrl }}">{{ product.Description }}</a>
        </h3>
        <app-review-stars
            [reviewCount]="product.ReviewCount"
            [stars]="product.ReviewStars"
        ></app-review-stars>
        <div class="product-card-savings text-center">
            <span *ngIf="product.DiscountAmount > 0" >SAVE {{ product.DiscountAmount | currency }}</span>
            <span *ngIf="!product.DiscountAmount">&nbsp;</span>
        </div>
        <div class="product-card-price text-center">
            <span>{{ product.SellingPrice | currency }}</span>
        </div>
    </div>
    <div *ngIf="showAddToCart" class="product-card-actions text-center">
        <button
            type="button"
            class="product-card-add-to-cart mdkit-button btn-success bmd-ripple btn btn-sm"
            (click)="addToCart(product.Webcode)"
            [disabled]="isAddingToCart"
        >
            Add To Cart
        </button>
    </div>
</div>
